import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "../layouts";
import {
  Auth,
  Users,
  Menu,
  Roles,
  Permissions,
  Dashboard,
  DashboardGeneral,
  Reports,
  Companies,
  Integrations,
  Recover,
  SocialForms,
  Sites,
  NewSiteForm,
  EnergyForms,
  ProductionForms,
  EffluentForms,
  WaterForms,
  WasteForms,
  DangerousForms,
  KPIsForms,
  AirEmissionsForms,
  FuelsForms,
  ConfigForms,
  ObjetivesAndBaseline,
  EnvironmentalObjetivesForms,
  Matrices,
  StrategicAxes,
  ConversionFactors,
  GEIFactors,
  GEIRevisionCalendar,
  DuplicatePeriods,
  Privacy,
  Terms,
  SbtiForms,
  SbtiReport,
  DocumentManager,
  EnvironmentalRiskMatrixForms,
  EnergyPerformance,
  WaterBalance
} from "../pages/admin";
import { useAuth } from "../hooks";
import { isMaster } from "../utils/checkPermission";

import Reset from "../pages/admin/Reset/Reset";
import { InviteComplete } from "../pages/admin/Invite";

export function AdminRouter() {
  const { user } = useAuth();
  const masterOnly = (Page) => isMaster(user?.role) ? loadLayout(AdminLayout, Page) : <Navigate to="/admin/dashboard" replace />;

  //console.log(user)
  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  return (
    <Routes>
      {/* Rutas públicas sin autenticación */}
      <Route path="/invite/:token" element={<InviteComplete />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />

      {!user ? (
        <>
          <Route path="/admin/*" element={<Auth />} />
          <Route path="/recover" element={<Recover />} />
          <Route path="/reset/:token" element={<Reset />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </>
      ) : (
        <>
          <Route path="/admin" element={loadLayout(AdminLayout, Dashboard)} />
          <Route path="/admin/dashboard/general" element={loadLayout(AdminLayout, DashboardGeneral)} />
          <Route path="/admin/dashboard" element={loadLayout(AdminLayout, Dashboard)} />
          <Route path="/admin/users" element={loadLayout(AdminLayout, Users)} />
          {/* <Route
            path="/admin/courses"
            element={loadLayout(AdminLayout, Courses)}
          /> */}
          <Route
            path="/admin/config/roles"
            element={masterOnly(Roles)}
          />
          <Route
            path="/admin/config/permissions"
            element={masterOnly(Permissions)}
          />
          <Route
            path="/admin/config/strategicaxes"
            element={loadLayout(AdminLayout, StrategicAxes)}
          />
          <Route path="/admin/menu" element={loadLayout(AdminLayout, Menu)} />
          {/* <Route
            path="/admin/newsletter"
            element={loadLayout(AdminLayout, Newsletter)}
          /> */}

          <Route
            path="/admin/reports"
            element={loadLayout(AdminLayout, Reports)}
          />

          <Route
            path="/admin/matrices/objetivos"
            element={loadLayout(AdminLayout, Matrices)}
          />

          <Route
            path="/admin/companies"
            element={loadLayout(AdminLayout, Companies)}
          />

          <Route path="/admin/sites" element={loadLayout(AdminLayout, Sites)} />
          <Route path="/admin/integrations" element={masterOnly(Integrations)} />

          <Route
            path="/admin/data/socialforms"
            element={loadLayout(AdminLayout, SocialForms)}
          />

          <Route
            path="/admin/siteforms/newsiteform"
            element={loadLayout(AdminLayout, NewSiteForm)}
          />

          <Route
            path="/admin/data/energyforms"
            element={loadLayout(AdminLayout, EnergyForms)}
          />

          <Route
            path="/admin/data/productionforms"
            element={loadLayout(AdminLayout, ProductionForms)}
          />
          <Route
            path="/admin/data/effluentforms"
            element={loadLayout(AdminLayout, EffluentForms)}
          />
          <Route
            path="/admin/data/waterforms"
            element={loadLayout(AdminLayout, WaterForms)}
          />
          <Route
            path="/admin/data/wasteforms"
            element={loadLayout(AdminLayout, WasteForms)}
          />
          <Route
            path="/admin/data/dangerousforms"
            element={loadLayout(AdminLayout, DangerousForms)}
          />

          <Route
            path="/admin/data/kpisforms"
            element={loadLayout(AdminLayout, KPIsForms)}
          />
            <Route
            path="/admin/data/airemissionsforms"
            element={loadLayout(AdminLayout, AirEmissionsForms)}
          />
                 <Route
            path="/admin/data/fuelsforms"
            element={loadLayout(AdminLayout, FuelsForms)}
          />

<Route
            path="/admin/config/configforms"
            element={loadLayout(AdminLayout, ConfigForms)}
          />

<Route
            path="/admin/config/conversionfactors"
            element={loadLayout(AdminLayout, ConversionFactors)}
          />

<Route
            path="/admin/config/geifactors"
            element={loadLayout(AdminLayout, GEIFactors)}
          />
          <Route
            path="/admin/config/gei-revision-calendar"
            element={masterOnly(GEIRevisionCalendar)}
          />

          <Route
            path="/admin/config/duplicate-periods"
            element={loadLayout(AdminLayout, DuplicatePeriods)}
          />

<Route
            path="/admin/data/baseline"
            element={loadLayout(AdminLayout, ObjetivesAndBaseline)}
          />
 <Route
            path="/admin/data/environmentalobjetives"
            element={loadLayout(AdminLayout, EnvironmentalObjetivesForms)}


          />
          <Route
            path="/admin/data/sbti"
            element={loadLayout(AdminLayout, SbtiForms)}
          />
          <Route
            path="/admin/data/environmentalriskmatrix"
            element={loadLayout(AdminLayout, EnvironmentalRiskMatrixForms)}
          />
          <Route
            path="/admin/data/energyperformance"
            element={loadLayout(AdminLayout, EnergyPerformance)}
          />
          <Route
            path="/admin/data/waterbalance"
            element={loadLayout(AdminLayout, WaterBalance)}
          />
          {/* Sin AdminLayout a propósito: es una página A4 lista para
              imprimir (Ctrl+P / Guardar PDF), no una pantalla de trabajo —
              mismo criterio que /privacy y /terms más arriba. */}
          <Route path="/admin/sbti-informe/:company" element={<SbtiReport />} />

          {/* Sin enlazar al menú todavía — accesible solo por URL directa
              hasta que se defina la ubicación definitiva del módulo. */}
          <Route
            path="/admin/document-manager"
            element={loadLayout(AdminLayout, DocumentManager)}
          />

          <Route path="*" element={<Navigate to="/admin" replace />} />
        </>
      )}
    </Routes>
  );
}
